import PropTypes from "prop-types";
import React from "react";

var InputText = function InputText(_ref) {
  var className = _ref.className,
      _onChange = _ref.onChange,
      style = _ref.style,
      value = _ref.value;

  return React.createElement("input", {
    className: "token string " + className,
    onChange: function onChange(e) {
      return _onChange(e.target.value, e.target.validity.valid);
    },
    style: style,
    type: "text",
    value: value
  });
};

InputText.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
  value: PropTypes.string.isRequired
} : {};

InputText.defaultProps = {
  className: "",
  style: {}
};

export default InputText;